<template>
	<div class="learner_program_data">

		<div class="row">
      <div class="col-12">
        <template v-if="program">
          <b-card class="text-center prog-lmi ace_sec" :aria-label="program.title">

						<template #header>
							<div class="hd_ic">
								<img :src="program.thumbnailURL" :alt="program.title + ' Thumbnail'">
							</div>
        			<div class="hd_txt">
								<v-clamp class="" autoresize :max-lines="2"> {{ program.title }} </v-clamp>
							</div>
      			</template>

						<div class="crd_content">

							<b-card-text>
	              <div class="row sec_row">
	                <div class="col-6 label">median income</div>
	                <div class="col-6 val ace_sec_txt" v-if="program.medianIncomePerYear" :aria-label="'median income is for program ' + program.title + ' is $' + program.medianIncomePerYear">
	                  $<span v-html="addCommaInNumber(program.medianIncomePerYear)"></span>
	                </div>
	                <div class="col-6 no_val" v-else>N/A</div>
	              </div>
	            </b-card-text>
	            <b-card-text>
	              <div class="row sec_row">
	                <div class="col-6 label">job postings</div>
	                <div class="col-6 val" v-if="program.totalJobPostings">
	                  <span v-html="addCommaInNumber(program.totalJobPostings)"></span>
	                </div>
	                <div class="col-6 no_val" v-else><strong>N/A</strong></div>
	              </div>
	            </b-card-text>
	            <b-card-text>
	              <div class="row sec_row">
	                <div class="col-6 label">job growth</div>
	                <div class="col-6 val" v-if="program.growthRate">
	                  <span v-html="(Math.round(program.growthRate * 100) / 100).toFixed(1)"></span><span>%</span>
	                </div>
	                <div class="col-6 no_val" v-else><strong>N/A</strong></div>
	              </div>
	            </b-card-text>

						</div>

						<div class="lnk_container">
							<a tabindex="0" href="javascript://" @click="navigateToCareerProspects">Career Prospects</a>
						</div>

          </b-card>
        </template>
        <template v-else>
          <b-card class="text-center prog-lmi ace_sec" aria-label="Program LMI data not available">

						<template #header>
							<div class="hd_ic">

							</div>
							<div class="hd_txt">

							</div>
						</template>

						<div class="crd_content">
	            <b-card-text>
	              <div class="mt-5">
	                <span>Program LMI data not available.</span>
	              </div>
	            </b-card-text>
						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'
	import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-program-labor-data',
		components: {
			VClamp
		},
    props: ['program'],
		methods: {
			addCommaInNumber (numValue) {
        return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      navigateToCareerProspects () {
        let routerParams = {
          cipCode: this.program.cipCode,
          programGuideCode: this.program.code,
          type: this.program.type,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideCareerProspects', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      }
		}
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramLaborData.vue